import { getToken } from "../../../shared/utils/common";


export class CommandCreateTemplate {
    async run(folderId: number, templateName: string) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${folderId}/ad_templates/`
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                    body: JSON.stringify({name: templateName, description:""})
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
